import { createSlice } from "@reduxjs/toolkit";

const medicationSlice = createSlice({
    name: "medications",
    initialState: {},
    reducers: {
        registerMedication: (state, action) => {
            const medication = action.payload;
            if (!medication?.id) return;

            if (!state[medication.id]) {
                state[medication.id] = medication;
            } else {
                console.warn(
                    `⚠️ Medication ${medication.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterMedications: (state, action) => {
            action.payload.forEach((medication) => {
                if (!medication?.id) return;

                if (!state[medication.id]) {
                    state[medication.id] = medication;
                } else {
                    console.warn(
                        `⚠️ Medication ${medication.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerMedication,
    bulkRegisterMedications
} = medicationSlice.actions;

export default medicationSlice.reducer;
